var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar-news" }, [
    _c("div", { staticClass: "navbar" }, [
      _vm.webConfig
        ? _c("div", { staticClass: "logo-wrapper" }, [
            _c("img", { attrs: { src: _vm.webConfig.site_logo, alt: "" } }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { ref: "leftBox", staticClass: "menu-box" },
        [
          _c(
            "el-scrollbar",
            { staticStyle: { height: "100%" } },
            [
              _vm.showMore
                ? [
                    _c(
                      "div",
                      { staticClass: "nav-box" },
                      _vm._l(_vm.menuList, function (item, index) {
                        return item.is_show != 0
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass: "nav-item",
                                class: { on: _vm.parentcur === index },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleParentCur(index, 1)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "nav-items" }, [
                                  _c("i", {
                                    staticClass: "iconfont",
                                    class: item.icon,
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(" " + _vm._s(item.menu_name)),
                                  ]),
                                ]),
                              ]
                            )
                          : _vm._e()
                      }),
                      0
                    ),
                  ]
                : [
                    _c(
                      "div",
                      { staticClass: "nav-box" },
                      [
                        _vm._l(
                          _vm.menuList.slice(0, _vm.showMax),
                          function (item, index) {
                            return item.is_show != 0
                              ? _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "nav-item",
                                    class: { on: _vm.parentcur === index },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleParentCur(index, 1)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "nav-items" }, [
                                      _c("i", {
                                        staticClass: "iconfont",
                                        class: item.icon,
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(" " + _vm._s(item.menu_name)),
                                      ]),
                                    ]),
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                        _vm._v(" "),
                        _vm.newMenuListArr.length - 1 > _vm.showMax
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "right",
                                  trigger: "hover",
                                  width: "176",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "popover-content" },
                                  _vm._l(
                                    _vm.menuList.slice(
                                      _vm.showMax,
                                      _vm.menuList.length
                                    ),
                                    function (item, index) {
                                      return item.is_show !== 0
                                        ? _c(
                                            "div",
                                            {
                                              key: "pop" + index,
                                              staticClass: "nav-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleParentCur(
                                                    index,
                                                    2,
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "nav-items" },
                                                [
                                                  _c("i", {
                                                    staticClass: "iconfont",
                                                    class: item.icon,
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.menu_name)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e()
                                    }
                                  ),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "nav-item popover-nav-item",
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _c("div", { staticClass: "nav-items" }, [
                                      _c("i", {
                                        staticClass:
                                          "iconfont icongenjinjilu-gengduo",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("更多")]),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "below-bar" },
        [
          _c("configapp"),
          _vm._v(" "),
          _c("notepad"),
          _vm._v(" "),
          _c("headerNotice"),
          _vm._v(" "),
          _c("personal"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }